export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';

export const GET_MASTER_CLIENTS_REQUEST = 'GET_MASTER_CLIENTS_REQUEST';
export const GET_MASTER_CLIENTS_SUCCESS = 'GET_MASTER_CLIENTS_SUCCESS';

export const GET_NEXT_CLIENT_PAGE = 'GET_NEXT_CLIENT_PAGE';
export const GET_NEXT_CLIENT_PAGE_SUCCESS = 'GET_NEXT_CLIENT_PAGE_SUCCESS';

export const GET_PREV_CLIENT_PAGE = 'GET_PREV_CLIENT_PAGE';
export const GET_PREV_CLIENT_PAGE_SUCCESS = 'GET_PREV_CLIENT_PAGE_SUCCESS';

export const GET_FIRST_CLIENT_PAGE = 'GET_FIRST_CLIENT_PAGE';
export const GET_FIRST_CLIENT_PAGE_SUCCESS = 'GET_FIRST_CLIENT_PAGE_SUCCESS';

export const GET_LAST_CLIENT_PAGE = 'GET_LAST_CLIENT_PAGE';
export const GET_LAST_CLIENT_PAGE_SUCCESS = 'GET_LAST_CLIENT_PAGE_SUCCESS';

export const ADD_CLIENT = 'ADD_CLIENT';
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const ADD_CLIENT_FAILURE = 'ADD_CLIENT_FAILURE';
export const ADD_CLIENT_TOAST_CLOSE = 'ADD_CLIENT_TOAST_CLOSE';
export const ADD_CLIENT_CORRECTION = 'ADD_CLIENT_CORRECTION';
export const IS_LOADING_TRUE = 'IS_LOADING_TRUE';
export const IS_LOADING_FALSE = 'IS_LOADING_FALSE';

export const CHECK_IF_CLIENT_EXISTS = 'CHECK_IF_CLIENT_EXISTS';
export const CHECK_IF_CLIENT_EXISTS_SUCCESS = 'CHECK_IF_CLIENT_EXISTS_SUCCESS';

export const EDIT_CLIENT = 'EDIT_CLIENT';
export const EDIT_CLIENT_SUCCESS = 'EDIT_CLIENT_SUCCESS';
export const EDIT_CLIENT_FAILURE = 'EDIT_CLIENT_FAILURE';
export const EDIT_CLIENT_TOAST_CLOSE = 'EDIT_CLIENT_TOAST_CLOSE';
export const EDIT_CLIENT_CORRECTION = 'EDIT_CLIENT_CORRECTION';

export const GET_CLIENT = 'GET_CLIENT';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';

export const SHOW_LICENSE_EXPIRED_DIALOG = 'SHOW_LICENSE_EXPIRED_DIALOG';
export const SHOW_LICENSE_EXPIRED_DIALOG_SUCCESS =
  'SHOW_LICENSE_EXPIRED_DIALOG_SUCCESS';

export const SHOW_MODULE_ACCESS_DIALOG = 'SHOW_MODULE_ACCESS_DIALOG';
export const SHOW_MODULE_ACCESS_DIALOG_SUCCESS =
  'SHOW_MODULE_ACCESS_DIALOG_SUCCESS';

export const SHOW_ERROR_MESSAGE_TOAST = 'SHOW_ERROR_MESSAGE_TOAST';
export const SHOW_ERROR_MESSAGE_TOAST_SUCCESS =
  'SHOW_ERROR_MESSAGE_TOAST_SUCCESS';

export const GET_ROLES_LIST = 'GET_ROLES_LIST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';

export const GET_DEFAULT_ROLES_LIST = 'GET_DEFAULT_ROLES_LIST';
export const GET_DEFAULT_ROLES_SUCCESS = 'GET_DEFAULT_ROLES_SUCCESS';

export const GET_CLIENTS_WITHOUT_PAGINATION_REQUEST =
  'GET_CLIENTS_WITHOUT_PAGINATION_REQUEST';
export const GET_CLIENTS_WITHOUT_PAGINATION_SUCCESS =
  'GET_CLIENTS_WITHOUT_PAGINATION_SUCCESS';

export const GET_ROLES_WITHOUT_PAGINATION_REQUEST =
  'GET_ROLES_WITHOUT_PAGINATION_REQUEST';
export const GET_ROLES_WITHOUT_PAGINATION_SUCCESS =
  'GET_ROLES_WITHOUT_PAGINATION_SUCCESS';

export const GET_NEXT_ROLE_PAGE = 'GET_NEXT_ROLE_PAGE';
export const GET_NEXT_ROLE_PAGE_SUCCESS = 'GET_NEXT_ROLE_PAGE_SUCCESS';

export const GET_PREV_ROLE_PAGE = 'GET_PREV_ROLE_PAGE';
export const GET_PREV_ROLE_PAGE_SUCCESS = 'GET_PREV_ROLE_PAGE_SUCCESS';

export const ADD_ROLE = 'ADD_ROLE';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'ADD_ROLE_FAILURE';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const GET_ROLE = 'GET_ROLE';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';

export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'

export const EDIT_ROLE = 'EDIT_ROLE';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';
export const EDIT_ROLE_FAILURE = 'EDIT_ROLE_FAILURE';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE';


export const ADD_ROLE_TOAST_CLOSE = 'ADD_ROLE_TOAST_CLOSE'

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';

export const GET_SUBJECT_LIST = 'GET_SUBJECT_LIST';
export const GET_SUBJECT_LIST_SUCCESS = 'GET_SUBJECT_LIST_SUCCESS';

export const GET_COURSE_LIST = 'GET_COURSE_LIST';
export const GET_COURSE_LIST_SUCCESS = 'GET_COURSE_LIST_SUCCESS';

export const SET_BULK_IMPORT_TEST = 'SET_BULK_IMPORT_TEST';
export const SET_BULK_IMPORT_TEST_SUCCESS = 'SET_BULK_IMPORT_TEST_SUCCESS';

export const SWITCH_SELECTED_TAB = 'SWITCH_SELECTED_TAB';
export const SWITCH_SELECTED_TAB_SUCCESS = 'SWITCH_SELECTED_TAB_SUCCESS';

export const ADD_USER_TOAST_CLOSE = 'ADD_USER_TOAST_CLOSE';

export const SET_ROLES_TAB = 'SET_ROLES_TAB';
export const SET_USERS_TAB = 'SET_USERS_TAB';
export const SET_CLIENTS_TAB = 'SET_CLIENTS_TAB';
export const UNAUTHORISED='UNAUTHORISED';

export const SEARCH_USER_MANAGMENT = 'SEARCH_USER_MANAGMENT';

export const SEARCH_CLIENTS_SUCCESS = 'SEARCH_CLIENTS_SUCCESS';
export const SEARCH_ROLES_SUCCESS = 'SEARCH_ROLES_SUCCESS';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';


export const SET_PAGINATION_TO_PAGE_ONE = 'SET_PAGINATION_TO_PAGE_ONE';
export const SET_PAGINATION_TO_PAGE_ONE_SUCCESS = 'SET_PAGINATION_TO_PAGE_ONE_SUCCESS';

export const RESET_PAGE_NUMBER_TO_NULL = 'RESET_PAGE_NUMBER_TO_NULL';
export const RESET_PAGE_NUMBER_TO_NULL_SUCCESS = 'RESET_PAGE_NUMBER_TO_NULL_SUCCESS';

export const ADD_ROLE_CHIP = 'ADD_ROLE_CHIP'
export const ADD_ROLE_CHIP_SUCCESS = 'ADD_ROLE_CHIP_SUCCESS'

export const REMOVE_ROLE_CHIP = 'REMOVE_ROLE_CHIP'
export const REMOVE_ROLE_CHIP_SUCCESS = 'REMOVE_ROLE_CHIP_SUCCESS'

export const ADD_USERS_CHIP = 'ADD_USERS_CHIP' 
export const ADD_USERS_CHIP_SUCCESS = 'ADD_USERS_CHIP_SUCCESS' 

export const REMOVE_USERS_CHIP = 'REMOVE_USERS_CHIP'
export const REMOVE_USERS_CHIP_SUCCESS = 'REMOVE_USERS_CHIP_SUCCESS'

export const CLEAR_CHIPS = 'CLEAR_CHIPS'
export const CLEAR_CHIPS_SUCCESS = 'CLEAR_CHIPS_SUCCESS'

export const SET_ROLES_SEARCH_ACTIVE_OPTION = 'SET_ROLES_SEARCH_ACTIVE_OPTION'
export const SET_ROLES_SEARCH_ACTIVE_OPTION_SUCCESS = 'SET_ROLES_SEARCH_ACTIVE_OPTION_SUCCESS'

export const SET_USERS_SEARCH_ACTIVE_OPTION = 'SET_USERS_SEARCH_ACTIVE_OPTION'
export const SET_USERS_SEARCH_ACTIVE_OPTION_SUCCESS = 'SET_USERS_SEARCH_ACTIVE_OPTION_SUCCESS'

export const SET_SEARCH_QUERY_BY_TAB = 'SET_SEARCH_QUERY_BY_TAB'

export const CLEAR_SEARCH_QUERY_TEXT = 'CLEAR_SEARCH_QUERY_TEXT'



